import axiosInstance from '../../helpers/axiosInstance'

export default function guardarUsuarioService (inputs) {
    return axiosInstance.post('usuario', inputs)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}